<p [ngClass]="class$ | async">
    {{value$ | async}}
</p>
